import { render } from "./HtmlMergeView.vue?vue&type=template&id=506f63aa"
import script from "./HtmlMergeView.vue?vue&type=script&lang=js"
export * from "./HtmlMergeView.vue?vue&type=script&lang=js"
script.render = render

export default script